import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { OnPremOverviewResponse } from '@utils/types/admin';

export const ADMIN_OVERVIEW_QUERY_KEY = 'adminOverview';

/**
 * Hook to fetch on-prem overview / system health data
 *
 * GET /api/admin/on-prem/overview
 *
 * Returns queue status, jobs metrics, storage info, and database totals
 */
export const useGetAdminOverview = (options?: { refetchInterval?: number }) => {
  const fetchOverview = async () => {
    const url = `api/admin/on-prem/overview`;
    const response = await Axios.get<OnPremOverviewResponse>(url);
    return response.data;
  };

  return useQuery<OnPremOverviewResponse, AxiosError<BaseError>>(
    [ADMIN_OVERVIEW_QUERY_KEY],
    fetchOverview,
    {
      useErrorBoundary: false,
      refetchInterval: options?.refetchInterval ?? 30000, // Default 30s auto-refresh
      staleTime: 10000 // Consider data stale after 10 seconds
    }
  );
};
